// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector } from 'reselect';

import { RootState } from '../../rootReducer';

export const supportReducerListRaw = (state: RootState) => state.createNewSupportReducer;

export const makeCreateNewSupportSelector = () => {
  return createSelector(
    supportReducerListRaw,
    (createNewSupportReducer) => createNewSupportReducer.data || {}
  );
}
export const makeCreateNewSupportError = () => {
  return createSelector(
    supportReducerListRaw,
    (createNewSupportReducer) => createNewSupportReducer.error
  );
}

export const makeCreateNewSupportIsLoading = () => {
  return createSelector(
    supportReducerListRaw,
    (createNewSupportReducer) => createNewSupportReducer.isLoading
  );
}
